import { modelState } from '@/utils/modelState';
import { QueryBuilder } from './QueryBuilder';
import { v4 as uuidv4 } from 'uuid';

export namespace ReturningGuestCondition {

    export const registryEntry: QueryBuilder.ConditionRegistryEntry = {
        key: "ReturningGuest",
        name: "Returning Guest",
        isCondition: isReturningGuestCondition,
        create: createReturningGuestCondition,
        hydrate: () => { },
        serialize: serializeReturningGuestCondition,
        deserialize: deserializeReturningGuestCondition,
        renderComponent: () => null
    };

    export const ReturningGuestCondition = Symbol("ReturningGuestCondition");
    export interface ReturningGuestCondition extends QueryBuilder.ConditionNodeChild {
        [ReturningGuestCondition]: boolean;
    }

    export function isReturningGuestCondition(condition?: QueryBuilder.ConditionNodeChild): condition is ReturningGuestCondition {
        if (!condition) {
            return false;
        }

        return (condition as ReturningGuestCondition)[ReturningGuestCondition] === true;
    }

    export function createReturningGuestCondition(skipHydration: boolean = false): ReturningGuestCondition {

        const condition: ReturningGuestCondition = {
            [QueryBuilder.Node]: true,
            [QueryBuilder.ConditionNodeChild]: true,
            [ReturningGuestCondition]: true,
            id: uuidv4(),
            version: modelState(0),
            dispose: () => { }
        };

        return condition;
    }

    function serializeReturningGuestCondition(condition: ReturningGuestCondition): QueryBuilder.ConditionChildNodeDtoWrapper {
        const alwaysDto: ReturningGuestConditionDto = {
            NodeId: condition.id
        };

        return {
            Type: "ReturningGuest",
            Value: alwaysDto
        };
    }

    interface ReturningGuestConditionDto extends QueryBuilder.NodeDto {
        //
    }

    function deserializeReturningGuestCondition(always: ReturningGuestConditionDto): ReturningGuestCondition {
        const condition = createReturningGuestCondition(true);
        return condition;
    }
}